"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgWatch = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M26.176 12a3 3 0 013 2.729l.316 3.454A7.978 7.978 0 0132 24a7.978 7.978 0 01-2.53 5.838l-.314 3.432A3 3 0 0126.16 36h-4.326a3 3 0 01-3-2.729l-.315-3.444A7.978 7.978 0 0116 24c0-2.303.973-4.378 2.53-5.838l.314-3.432A3 3 0 0121.83 12h4.346zm-5.517 19.271l.167 1.819c.047.517.481.912 1.004.91h4.334a1 1 0 001-.911l.167-1.813A7.97 7.97 0 0124 32a7.97 7.97 0 01-3.34-.729zM24 18c-1.46 0-2.798.521-3.838 1.388A5.98 5.98 0 0018 24a6 6 0 106-6zm0 2a1 1 0 011 1v2.586l1.207 1.207a1 1 0 01-1.414 1.414l-1.5-1.5A1 1 0 0123 24v-3a1 1 0 011-1zm2.18-6h-4.35a1 1 0 00-.994.911l-.167 1.813A7.97 7.97 0 0124 16a7.97 7.97 0 013.352.734l-.168-1.824A1.001 1.001 0 0026.18 14z",
    id: "watch_svg__a"
  }));
};

var _default = SvgWatch;
exports.default = _default;